const url = window.location.href;

export const API_BASE_URL: string | undefined = url.includes("www.")
    ? process.env.REACT_APP_BASE_URL_PROD
    : url.includes("wwwqa.")
        ? process.env.REACT_APP_BASE_URL_QA
        : process.env.REACT_APP_BASE_URL_DEV;

export const CLIENT_ID: string | undefined = url.includes("www.")
    ? process.env.REACT_APP_CLIENT_ID_PROD
    : url.includes("wwwqa.")
        ? process.env.REACT_APP_CLIENT_ID_QA
        : process.env.REACT_APP_CLIENT_ID_DEV;

export const REDIRECT_URL: string | undefined = url.includes("www.")
    ? process.env.REACT_APP_REDIRECT_URL_PROD
    : url.includes("wwwqa.")
        ? process.env.REACT_APP_REDIRECT_URL_QA
        : process.env.REACT_APP_REDIRECT_URL_DEV;

export const PROVIDER_APP_ID: string | undefined = url.includes("www.")
    ? process.env.REACT_APP_PROVIDER_APP_ID_PROD
    : url.includes("wwwqa.")
        ? process.env.REACT_APP_PROVIDER_APP_ID_QA
        : process.env.REACT_APP_PROVIDER_APP_ID_DEV;